---
title: "Actual lines from tech recruiter emails"
subtitle: "you're probably happy at your current job, but—"
date: 2025-12-10 20:26
---

1. Look, I know you're probably happy at your current job, but if you ANY great engineers looking, please send them my way and I'll get you a breakfast burrito or a smoothie, coffee… whatever, from any place in town. Seriously, that's it.

2. Haven't heard back, so here's another email just in case the last fourteen got lost in the digital void.

3. There's catered meals, wellness and learning stipends, a gym membership, air conditioning, four bathrooms, two bedrooms, in-office laundry, and dental insurance.

4. You'll get to work with cutting-edge technology, including Kubernetes, Bash, Linux, ASCII, and binary trees.

5. We're building an integrated SaaS platform for pet romance. This may seem like a niche market, but it's a $200 billion industry that's largely untouched by technology.

6. We're lucky to have quite a bit of momentum with our growth! We would love for you to be part of this ride! If this opportunity sounds interesting to you, I’d like to connect you with the team and share more! We'd love to tell you! About the impact! You can have working with us!

7. There's great signs of product–market fit, or as we like to call it, dog–kennel fit.

8. You don't have to respond unless you're interested… I mean, not like someone as cool as you would ever work with someone like me… what if we went on a call together… aha just kidding… unless?

9. The founders have raised a HUGE SEED.

10. If you're interested in joining a high-caliber team, where you get to work with smart people, in a culture that values strong technical skill, on a team that's all S-tier, where everyone's from the top CS programs, with coworkers who are ex-OpenAI, ex-Google, ex-Meta, ex-NVIDIA (not really, that's a joke), ex-Apple, ex-Anthropic, and ex-Microsoft, then… what was I talking about?

11. If you're not looking, let's connect anyway. I have 45 other positions I'm recruiting for and I can't tell the difference between any of them.

12. They're still in stealth, so I can't say much about the product in writing. Not that I could say anything about the product at all.

13. Your previous work as a Teaching Assistant for Introduction to Machine Learning (6.036) makes you a great fit for being our first Senior Marketing Manager.

14. How about two burritos? Two burritos *and* a smoothie?

15. Are you working on challenging problems? Do you wake up every morning looking forward to your job? Is your work interesting enough that you dream about it despite all attempts not to?

16. I'm sorry in advance, but your LinkedIn profile is insanely impressive. I can tell you've worked hard to get where you're at! And your profile picture looks amazing. Are you free on Thursday for dinner and a show?

17. I am hoping I am not unlucky with my reach outs. I am also hoping you didn't get eaten by an Alligator.

18. Your previous work as Software Engineer at Sugar and Senior Software Engineer at Sugar make you a great fit for being a Member of Technical Staff at Sugar.

19. If you're up to it, we can hop on a quick phone call, or we can go straight to the five-hour take-home technical screen.

20. While we're headquartered in San Francisco, we have a flexible work-from-home policy for everyone who lives in the Bay Area. Of our hybrid employees, 83% only come into the office once a day.

21. Use ChatGPT daily? So do millions of Americans. Have you heard about how Brightwater's revolutionizing sparkling water?
